import localeText from '../../../../locales/datagrid'
import {
    GridFilterItemPro,
    GridFilterModelPro,
    LinkOperator,
} from '../utils/filterModelPro'
import FilterPanelSelect from './PanelSelect'
import React from 'react'

export default function FieldLinkOperator({
    item,
    onFilterModelChange,
    className,
}: {
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    className?: string
}) {
    return (
        <FilterPanelSelect
            label=""
            options={[
                {
                    value: LinkOperator.And,
                    label: localeText.filterPanelOperatorAnd,
                },
                {
                    value: LinkOperator.Or,
                    label: localeText.filterPanelOperatorOr,
                },
            ]}
            value={item.linkOperator || LinkOperator.And}
            className={className}
            onValueChange={valor => {
                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id
                            ? {
                                  ...p,
                                  linkOperator: valor,
                              }
                            : p,
                    ),
                }))
            }}
        />
    )
}
